<template>
  <div id="chatbot"></div>
</template>

<script>
export default {
  name: "ChatBot",
  mounted() {
    const injectScript = document.createElement("script");
    injectScript.src = "//code.tidio.co/0nii2vqifqjpppe6e8tkg1kp2wkmgvox.js";
    injectScript.async = true;
    document.head.appendChild(injectScript);

    injectScript.onerror = () => {
      console.error("Error loading ChatBot script");
    };
  },
};
</script>
